import React from 'react';
import styled from 'styled-components';
import { Colors, Fonts } from '../utils/colors';

export const TerminalFrame = (props: {
  title?: string
  children: React.ReactNode
}) => {
  return (
    <Frame>
      {props.title && (
        <TitleBar>
          <PromptMark>&gt;</PromptMark>
          <Title>{props.title}</Title>
        </TitleBar>
      )}
      <Body>{props.children}</Body>
    </Frame>
  )
}

const Frame = styled.div`
  background: ${Colors.terminalPanel};
  border: 1px solid ${Colors.terminalBorder};
  box-shadow: ${Colors.frameShadow};
`;

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid ${Colors.terminalBorder};
  font-family: ${Fonts.mono};
`;

const PromptMark = styled.span`
  color: ${Colors.destructGreen};
  text-shadow: 0 0 8px ${Colors.terminalGlow};
`;

const Title = styled.span`
  color: ${Colors.destructGreen};
  font-size: 13px;
  letter-spacing: 0.04em;
`;

const Body = styled.div`
  padding: 18px 16px 20px;
`;
